import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as UploadCloudIcon } from './uploadCloud.svg';

export const UploadCloud = IconHOC(UploadCloudIcon);
